import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { MapNotifier } from '../notifiers/map-notifier';
import { MapState } from '../states/map-state';

@Injectable({ providedIn: 'root' })
export class MapProvider extends BaseProvider<MapNotifier, MapState> {
  constructor() {
    super(MapNotifier);
  }
}
 